module.exports = __webpack_public_path__ + "img/rtl.e64d0a1.png";